const allowedChars = /[^-А-яёЁ0-9\s’/`~!#*$@_%+=.,^&(){}[\]|;:”"<>?\\]/g;

export const emojiValidation = (value: string): boolean => {
  return allowedChars.test(value);
};
